import mixpanel from "mixpanel-browser"

let initialized = false

export const Mixpanel = {
	init: () => {
		if (initialized) return
		initialized = true
		mixpanel.init("bf000bcfd1e2e052b9ce2a9f899d9dcd", {
			autocapture: true,
			record_sessions_percent: 100,
			api_host: "https://api-eu.mixpanel.com",
			debug: false,
			track_pageview: true,
			ip: true,
		})
	},
	identify: (id: string) => {
		if (!initialized) return
		mixpanel.identify(id)
	},
	alias: (id: string) => {
		if (!initialized) return
		mixpanel.alias(id)
	},
	track: (event: string, properties?: Record<string, unknown>) => {
		if (!initialized) return
		mixpanel.track(event, properties)
	},
	people: {
		set: (props: object) => {
			if (!initialized) return
			mixpanel.people.set(props)
		},
	},
	reset: () => {
		if (!initialized) return
		mixpanel.reset()
	},
}
